import { useEffect } from "react";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { useTypedQuery } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CheckInService } from "models";

const sortCheckInServices = (checkInServices: CheckInService[]) => checkInServices.sort((a, b) => b.id - a.id);

export const useLocationCheckInServicesQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  const query = useTypedQuery({
    queryKey: CheckInServicesQueryKeys.locationList,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data.check_in_services,
    select: sortCheckInServices,
    enabled: false
  });

  useEffect(() => {
    if (selectedLocation?.id) query.refetch();
  }, [selectedLocation?.id]);

  return query;
};
